import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ScheduledTransfer } from '../../../../models/scheduled-transfer.model';

@Component({
	selector: 'app-cancel-transfer-modal',
	styleUrls: ['./cancel-transfer-modal.component.scss'],
	templateUrl: './cancel-transfer-modal.component.html',
})
export class CancelTransferModalComponent {
	@Input() beneficiaryName: string = '';
	@Output() close = new EventEmitter<void>();
	@Output() confirm = new EventEmitter<void>();

	@Input() hasDependent: boolean = false;
	@Input() transfer: ScheduledTransfer | null = null;

	getBeneficiariesText(): string {
		if (!this.beneficiaryName) return '';

		if (this.hasDependent) {
			return `${this.beneficiaryName} e dependente(s)`;
		}

		return this.beneficiaryName;
	}

	onClose(): void {
		this.close.emit();
	}

	onConfirm(): void {
		this.confirm.emit();
	}
}
